import React, { Component } from 'react';
import { Dropdown, Form } from 'semantic-ui-react';
import ReactTable from 'react-table';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { ItemStorageLocationEnum } from 'Common/FieldEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';

class ItemStorageLocationInfo extends Component {
  state = {
    selected: [],
    columns: [
      {
        Header: 'Site Id',
        accessor: ItemStorageLocationEnum.SiteId,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Site Description',
        accessor: ItemStorageLocationEnum.SiteDescription,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Storage Location',
        accessor: ItemStorageLocationEnum.StorageLocation,
        ...ReactTableWrapperColumnProperties,
        Cell: ({ original }) => {
          let cog;
          const value = original[ItemStorageLocationEnum.StorageLocation]
            ? original[ItemStorageLocationEnum.StoreId]
            : 0;
          return (
            <Dropdown
              className={'itemGridDropdown'}
              search
              selection
              options={this.props.gridStorageDropDownData}
              onChange={(e, { value }) => {
                this.handleStorageLocationChange(value, original);
              }}
              value={value}
              onOpen={e => {
                if (e && e.currentTarget) {
                  cog = e.currentTarget.closest('.rt-td');
                }
                if (cog) {
                  cog.style.zIndex = 2;
                  cog.style.overflow = 'inherit';
                }
              }}
              onClose={() => {
                if (cog) {
                  cog.style.zIndex = null;
                  cog.style.overflow = 'hidden';
                }
              }}
            />
          );
        },
      },
    ],
  };

  handleStorageLocationChange = (value, original) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [{}];
    formValues[0][original.SiteId] = value;
    this.props.input.onChange(formValues);
  };

  getTrProps = () => {
    return {
      style: {
        height: 50,
      },
    };
  };

  prepareTableData = () => {
    const { gridStorageDropDownData } = this.props;
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.forEach(value[0], (StoreId, SiteId) => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemStorageLocationEnum.SiteId]: SiteId,
        });
        if (index > -1) {
          const dataRow = gridStorageDropDownData.find(store => {
            return store.value === StoreId;
          });
          if (dataRow) {
            dataSourceCopy[index][ItemStorageLocationEnum.StorageLocation] =
              dataRow.text;
            dataSourceCopy[index][ItemStorageLocationEnum.StoreId] =
              dataRow.value;
          }
        }
      });
    }
    return dataSourceCopy;
  };

  render() {
    const {
      fetchingItemStorageLocation,
      gridStorageLocationDataLoading,
    } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          loading={
            fetchingItemStorageLocation || gridStorageLocationDataLoading
          }
          data={this.prepareTableData()}
          resizable={true}
          className={'-striped -highlight'}
          defaultFilterMethod={caseInsensitiveFilter}
          noDataText={
            fetchingItemStorageLocation && gridStorageLocationDataLoading
              ? ''
              : 'No items found'
          }
          columns={this.state.columns}
          getTrProps={this.getTrProps}
        />
      </Form.Field>
    );
  }
}

export const ItemStorageLocationInfoContainer = ItemStorageLocationInfo;



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/containers/ItemStorageLocationInfo.js